import { EndpointSetting, EnumEndpointsName } from "@/constants/app/type";
import { FlightState } from "../type";

const getListMinFare = (payload: any): any[] => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.listMinFare)) return payload.listMinFare
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export const callbackSearchMinFlights: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: EnumEndpointsName.SEARCH_MIN_FLIGHTS_V1 | EnumEndpointsName.SEARCH_MIN_FLIGHTS
) => {
  state[endpointName].loading = false
  state[endpointName].error = null
  state[endpointName].success = true

  const route = `${action.meta.arg.body.itinerary.startPoint}${action.meta.arg.body.itinerary.endPoint}`
  const listMinFare = getListMinFare(action?.payload)

  if (endpointName === EnumEndpointsName.SEARCH_MIN_FLIGHTS_V1) {
    state[endpointName].data = listMinFare
    return
  }

  for (let i = 0; i < listMinFare.length; i++) {
    const minFare = listMinFare[i];
    const dateStr = String(minFare?.date || "")
    const [, month] = dateStr.split('-')
    if (!month) continue
    if (!state.minFlightsByMonths[month]) {
      state.minFlightsByMonths[month] = {
        [minFare.date]: {
          ...minFare,
          route
        }
      }
    } else {
      state.minFlightsByMonths[month][minFare.date] = {
        ...minFare,
        route
      }
    }
  }
}